import '../styles/main.scss';

require("jquery");
require('bootstrap/js/dist/collapse');
//require('../../node_modules/jquery.cookie/jquery.cookie');

// Swiper Slider
const Swiper = require('../../node_modules/swiper/dist/js/swiper.js');

// Velocity
require('../../node_modules/velocity-animate/velocity.js');
require('../../node_modules/velocity-ui-pack/velocity.ui.js');

require('cookieconsent/src/cookieconsent');

$(document).ready(function () {

    console.log('Basic Module Loaded!');

    /**
     * Hamburger
     */
    $('.js-hamburger').click(function () {

        if ($('.js-hamburger').hasClass('is-active')) {
            $('.js-hamburger').removeClass('is-active');
            $('body').toggleClass('nav-show nav-hidden ');
        } else {
            $('.js-hamburger').addClass('is-active');
            $('body').toggleClass('nav-hidden nav-show');

            $('.navbar-mobile .menu-item').velocity("transition.slideLeftIn", {
                stagger: 100,
                duration: 350
            });

        }

        return false;
    });

    $('.js-backdrop').click(function () {

        $('.js-hamburger').removeClass('is-active');
        $('body').removeClass('nav-show').addClass('nav-hidden ');

        return false;
    });



    /**
     * Swiper Slider
     * https://github.com/nolimits4web/Swiper
     *
     */

    if ($(".project-slider").length > 0) {

        $('.collapse').on('hidden.bs.collapse', function () {

            $.ajax({
                url: myAjax.ajaxurl,
                type: 'POST',
                data: {
                    'action': 'setSession',
                    'collapse': 'hidden'
                },
                success: function (data) {
                    console.log(data);
                },
                error: function(errorThrown){
                    console.log(errorThrown);
                }
            });

        });

        $('.collapse').on('shown.bs.collapse', function () {

            $.ajax({
                url: myAjax.ajaxurl,
                type: 'POST',
                data: {
                    'action': 'setSession',
                    'collapse': 'shown'
                },
                success: function (data) {
                    console.log(data);
                },
                error: function(errorThrown){
                    console.log(errorThrown);
                }
            });

        });

        // Fade In Elements
        $('.project-slider').velocity("transition.fadeIn", {
            duration: 1000
        });

    }

    // Check if element has been found
    if ($(".gallery-top").length > 0) {

        var galleryTop = new Swiper('.gallery-top', {
            speed: 500,
            effect: 'slide',
            spaceBetween: 0,
            simulateTouch: false,
            noSwiping: false,
            pagination: {
                el: '.swiper-pagination',
                type: 'bullets',
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            keyboard: {
                enabled: true,
                onlyInViewport: false,
            },
            preloadImages: false,
            lazy: true,
            lazyLoadingInPrevNext: true,
            loadPrevNextAmount: 1
        });

        var galleryThumbs = new Swiper('.gallery-thumbs', {
            spaceBetween: 0,
            centeredSlides: true,
            slidesPerView: 3,
            touchRatio: 0.2,
            slideToClickedSlide: true
        });

        galleryTop.controller.control = galleryThumbs;
        galleryThumbs.controller.control = galleryTop;

    }

    // Check if element has been found
    if ($(".post-carousel").length > 0) {

        // Fade In Elements
        $('.post-carousel .hentry').velocity("transition.slideRightIn", {
            stagger: 250,
            duration: 500
        });

        var postCarousel = new Swiper('.post-carousel', {
            speed: 500,
            effect: 'slide',
            spaceBetween: 0,
            simulateTouch: false,
            autoHeight: false,
            noSwiping: false,
            navigation: {
                nextEl: '.post-navigation-next',
                prevEl: '.post-navigation-prev',
            },
            keyboard: {
                enabled: true,
                onlyInViewport: false,
            },
            preloadImages: false,
            lazy: true,
            lazyLoadingInPrevNext: true,
            loadPrevNextAmount: 1,
            slideToClickedSlide: true
        });
    }

    if ($('body').hasClass('home')) {

        var quotes = new Array(
            '<span id="1">einfach.</span><span id="2">durchdacht.</span><span id="3">roh.</span>',
            '<span id="1">sinnvoll.</span><span id="2">reduziert.</span><span id="3">roh.</span>',
            '<span id="1">auff&aumlllig.</span><span id="2">unauff&aumlllig.</span><span id="3">roh.</span>'
            ),
            randno = quotes[Math.floor(Math.random() * quotes.length)];

        $('.animated-fade').html(randno);

        $('.animated-fade span').velocity("transition.slideLeftIn", {
            stagger: 500,
            duration: 1000
        });

    }

    if ($('.animated-title').length > 0) {

        $('.animated-title span').velocity("transition.slideLeftIn", {
            stagger: 250,
            duration: 500
        });

    }

    if ($('.animate-content').length > 0) {

        $('.animate-content').velocity("transition.slideRightIn", {
            stagger: 100,
            duration: 350
        });

    }

    /**
     * Cookie Consent
     */
    window.cookieconsent.initialise({
        "palette": {
            "popup": {
                "background": "#ffffff",
                "text": "#000000"
            },
            "button": {
                "background": "transparent",
                "text": "#000000",
                "border": "#000000"
            }
        },
        "position": "bottom-right",
        //"static": true,
        "content": {
            "message": "Diese Webseite verwendet Cookies. Durch das Nutzen dieser Seite sind Sie mit der Verwendung von Cookies einverstanden. ",
            "dismiss": "Okay",
            "link": "Mehr Informationen",
            "href": "https://www.roh-arch.at/datenschutz"
        }
    });


});


// WEBPACK FOOTER //
// ./_assets/scripts/app.js